import "./style.scss";
import { useFranchiseWithUs } from "./hooks";
import { useComponent, useElement, useLocale, useWidget } from "../../../hooks";
import { brandInfo } from "../../../constant";

export const FranchiseWithUs = () => {
  const { t } = useLocale();
  const Img = useElement("Img");
  const Button = useElement("Button");
  const Input = useElement("Input");
  const Banner = useWidget("Banner");
  const PropertyRequirements = useComponent("PropertyRequirements");
  const {
    sendFranchiseRequest,
    name,
    setname,
    email,
    setemail,
    mobile,
    setmobile,
    city,
    setcity,
    pinCode,
    setpinCode,
    message,
    setmessage,
    scrollToApplyForFranchise,
  } = useFranchiseWithUs();

  return (
    <>
      <Banner
        title={t("becomePartner")}
        buttonAlign="center"
        align="right"
        image="franchise-banner.jpg"
        cta={{ label: t("franchiseCTA.apply"), onClick: scrollToApplyForFranchise }}
      />
      <section className="franchise-with-us mb60-mbs40 mt40">
        <div className="wrapper jumbo-container">
          <div className="section-title-wrap">
            <div className="section-title">
              <h2 className="heading-02">{t("franchisePage.whyPartner")}</h2>
            </div>
            <ul className="franchise-benefits">
              <li>{t("franchisePage.benefit1")}</li>
              <li>{t("franchisePage.benefit2")}</li>
              <li>{t("franchisePage.benefit3")}</li>
              <li>{t("franchisePage.benefit4")}</li>
              <li>{t("franchisePage.benefit5")}</li>
              <li>{t("franchisePage.benefit6")}</li>
              <li>{t("franchisePage.benefit7").replace("{brand}", brandInfo.name.capital)}</li>
              <li>{t("franchisePage.benefit8")}</li>
              <li>{t("franchisePage.benefit9")}</li>
              <li>{t("franchisePage.benefit10")}</li>
            </ul>
          </div>
          <Img src="baecome-partner-person.jpg" />
        </div>
        <div className="wrapper jumbo-container about-franchise mt40">
          <div className="flex">
            <Img src="baecome-partner-2.jpg" />
            <div className="content">
              <h4>{t("franchisePage.focoTitle")}</h4>
              <p>{t("franchisePage.focoDescription")}</p>
            </div>
          </div>
          <div className="flex">
            <Img src="onetime-investment.jpg" />
            <div className="content">
              <h4>{t("franchisePage.oneTimeInvestmentTitle")}</h4>
              <p>{t("franchisePage.oneTimeInvestmentDescription")}</p>
            </div>
          </div>
        </div>
        <div className="wrapper mt40">
          <Button
            className="btn btn-primary mauto mt20 btn-big"
            onClick={scrollToApplyForFranchise}
          >
            {t("franchiseCTA.apply")}
          </Button>
        </div>
      </section>
      <PropertyRequirements />
      <section className="franchise-display-media">
        <div className="jumbo-container">
          <div className="section-title">
            <h2 className="heading-02">Our Detailing Stores</h2>
          </div>
        </div>
        <div className="jumbo-container wrapper">
          <div className="video-box">
            <Img src="franchise-media1-min.jpg" />
            <i className="hi-play_circle_filled"></i>
          </div>
          <div className="grid-box">
            <Img hasZoom src="franchise-media2-min.jpg" />
            <Img hasZoom src="franchise-media4-min.jpg" />
            <Img hasZoom src="franchise-media3-min.jpg" />
            <Img hasZoom src="franchise-media5-min.jpg" />
          </div>
        </div>
      </section>
      <div
        id="apply-for-franchise"
        className="apply-for-franchise body-background franchise-page"
        style={{ minHeight: 1 }}
      >
        <div className="jumbo-container">
          <div className="card wrapper">
            <form onSubmit={sendFranchiseRequest} noValidate>
              <div className="title-section">
                <h1 className="heading-02">Become our Partner</h1>
                <p>Take your first step towards Automotive Entrepreneurship!</p>
              </div>
              <div className="contact-form-section">
                <div className="form-group input-box">
                  <Input
                    className="input"
                    value={name}
                    onChange={(e) => setname(e.target.value)}
                    name="name"
                    placeholder={t("fullName")}
                  />
                </div>
                <div className="form-block">
                  <div className="form-group input-box">
                    <Input
                      className="input"
                      value={email}
                      onChange={(e) => setemail(e.target.value)}
                      type="email"
                      name="Email"
                      placeholder="Email"
                    />
                  </div>
                  <div className="form-group input-box">
                    <Input
                      className="input"
                      value={mobile}
                      onChange={(e) => setmobile(e.target.value)}
                      type="tel"
                      name="Mobile"
                      placeholder="Mobile"
                    />
                  </div>
                </div>
                <div className="form-block">
                  <div className="form-group">
                    <Input
                      className="input"
                      value={city}
                      onChange={(e) => setcity(e.target.value)}
                      name="city"
                      placeholder="Interested City"
                    />
                  </div>
                  <div className="form-group">
                    <Input
                      className="input"
                      value={pinCode}
                      onChange={(e) => setpinCode(e.target.value)}
                      name="pinCode"
                      placeholder="Location Preference For Franchise"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    className="input textarea"
                    value={message}
                    onChange={(e) => setmessage(e.target.value)}
                    name="message"
                    placeholder="Other Details"
                  />
                </div>
                <Button className="btn btn-primary" type="submit">
                  {t("submit")}
                </Button>
              </div>
            </form>
            <Img src="partnership-form.jpg" />
          </div>
        </div>
      </div>
    </>
  );
};
